'use strict';

import React from 'react'

import { Link as RouterLink } from 'react-router-dom'

export default class Link extends React.Component
{
	constructor (props)
	{
		super(props);
	}

	render ()
	{
		const props = this.props;
		const is_link = props.href ? true : false;
		var output;

		if (is_link && props.href !== document.location.pathname)
		{
			output =
			(
				<RouterLink to={ props.href } className={ props.className } { ...props }>
					{ props.children }
				</RouterLink>
			);
		}
		else
		{
			output =
			(
				<span className={ props.className } { ...props }>
					{ props.children }
				</span>
			);
		}

		return output;
	}
}